export default __webpack_public_path__ + "static/media/juice-headline-desktop@3x.968404bd.png";